/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CreateBankTransfersRequest
 */
export interface CreateBankTransfersRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateBankTransfersRequest
     */
    'paymentRequestIds': Array<string>;
    /**
     * yyyy-MM-dd format Date when the bank transfers are to be executed.
     * @type {string}
     * @memberof CreateBankTransfersRequest
     */
    'transferDate': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBankTransfersRequest
     */
    'fileFormat': CreateBankTransfersRequestFileFormatEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateBankTransfersRequest
     */
    'bankAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBankTransfersRequest
     */
    'bankAccountRecordId': string;
}

export const CreateBankTransfersRequestFileFormatEnum = {
    disableLineBreak: 'ZENGIN_DISABLE_LINE_BREAK',
    enableLineBreak: 'ZENGIN_ENABLE_LINE_BREAK',
    csv: 'ZENGIN_CSV'
} as const;

export type CreateBankTransfersRequestFileFormatEnum = typeof CreateBankTransfersRequestFileFormatEnum[keyof typeof CreateBankTransfersRequestFileFormatEnum];


